import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deletePromptFragmentAPI } from "Api/promptFragments";
import { consoleLog } from "helpers";

const EditOrDeletePromptFragmentsBtn = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    setPromptFragmentsFormData,
    initialPromptFragmentsFormState,
    setFetchPromptFragments,
    setIsOpenPromptFragmentsEditForm,
  } = useGlobalContext();

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    if (isDeleting) return;
    const response = await deletePromptFragmentAPI(
      { id: props.cell.row.original.id },
      setIsDeleting,
      token
    );
    if (response) {
      toast.success(`Prompt fragment deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchPromptFragments(true);
    }
    if (!response) {
      toast.error("Prompt fragment deletion failed");
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setPromptFragmentsFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
            isActive: props.cell.row.original.isActive ? "active" : "inactive",
          }
        : {
            ...initialPromptFragmentsFormState,
            isActive: initialPromptFragmentsFormState.isActive
              ? "active"
              : "inactive",
          }
    );
    setIsOpenPromptFragmentsEditForm(true);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />

      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditOrDeletePromptFragmentsBtn;
